import React, { useState, useEffect, useMemo, useRef } from "react";
import { CSVLink } from "react-csv";

// Importações do TanStack Table
import {
    useReactTable,
    getCoreRowModel,
    getFilteredRowModel,
    getSortedRowModel,
    getFacetedRowModel,
    getFacetedUniqueValues,
    flexRender,
} from "@tanstack/react-table";

// Seus imports de serviço e módulos
import { pega_ranking_soma_bolsa, pega_matriz_curricular } from "../../services/api";
import { ConverteSerie } from "./modulo";

// Imports do React-Bootstrap
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import Dropdown from 'react-bootstrap/Dropdown';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner'; // NOVO: Importar o Spinner
import { Popover, OverlayTrigger } from "react-bootstrap";


// COMPONENTE DE FILTRO REATORADO COM REACT-BOOTSTRAP (CheckboxDropdownFilter)
const CheckboxDropdownFilter = ({ column }) => {
    const { getFacetedUniqueValues, getFilterValue, setFilterValue } = column;

    const facetedValues = getFacetedUniqueValues();
    const sortedUniqueValues = useMemo(
        () => Array.from(facetedValues.keys()).sort(),
        [facetedValues]
    );

    const filterValues = (getFilterValue() || []);

    const handleCheckboxChange = (value) => {
        const newFilterValues = [...filterValues];
        if (newFilterValues.includes(value)) {
            const index = newFilterValues.indexOf(value);
            if (index > -1) {
                newFilterValues.splice(index, 1);
            }
        } else {
            newFilterValues.push(value);
        }
        setFilterValue(newFilterValues.length > 0 ? newFilterValues : undefined);
    };

    const getButtonText = () => {
        if (filterValues.length === 0) return "Todas";
        if (filterValues.length === 1) return filterValues[0];
        return `${filterValues.length} selecionadas`;
    };

    return (
        <Dropdown>
            <Dropdown.Toggle variant="light" size="sm" className="w-100 text-start">
                {getButtonText()}
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ maxHeight: '200px', overflowY: 'auto' }}>
                {sortedUniqueValues.map(value => (
                    <Dropdown.Item key={value} as="div" onClick={(e) => e.stopPropagation()}>
                        <Form.Check
                            type="checkbox"
                            id={`checkbox-${value}`}
                            label={`${value} (${facetedValues.get(value)})`}
                            checked={filterValues.includes(value)}
                            onChange={() => handleCheckboxChange(value)}
                        />
                    </Dropdown.Item>
                ))}
                {filterValues.length > 0 && (
                    <>
                        <Dropdown.Divider />
                        <Dropdown.Item as="div" className="text-center">
                            <Button
                                variant="link"
                                size="sm"
                                onClick={() => setFilterValue(undefined)}
                            >
                                Limpar seleção
                            </Button>
                        </Dropdown.Item>
                    </>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};

// COMPONENTE DE FILTRO DE SELECT REATORADO COM REACT-BOOTSTRAP (SelectColumnFilter)
const SelectColumnFilter = ({ column }) => {
    const facetedValues = column.getFacetedUniqueValues();
    const sortedUniqueValues = useMemo(
        () => Array.from(facetedValues.keys()).sort(),
        [facetedValues]
    );

    return (
        <Form.Select
            value={column.getFilterValue() || ''}
            onChange={e => column.setFilterValue(e.target.value || undefined)}
            onClick={e => e.stopPropagation()}
            size="sm"
            className="mt-1"
        >
            <option value="">Todos</option>
            {sortedUniqueValues.map(value => (
                <option key={value} value={value}>
                    {value} ({facetedValues.get(value)})
                </option>
            ))}
        </Form.Select>
    );
};


// COMPONENTE PRINCIPAL
const Ranking_Alunos_Serie_BolsaBT = (props) => {
    const [data2, setData2] = useState([]);
    const [matrizCurricular, setMatrizCurricular] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    // NOVO: Estado para os dados que a tabela vai renderizar
    const [displayData, setDisplayData] = useState([]);

    // NOVO: Estados para o painel de controle de alunos em risco
    const [reportType, setReportType] = useState('');
    const [referenceCycle, setReferenceCycle] = useState(3); // Padrão para o ciclo atual
    const [threshold, setThreshold] = useState(50);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', '', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes'];
    const perfil = JSON.parse(localStorage.getItem("perfil"));

    const csvHeaders = [
        { label: "Unidade", key: "unidade" },
        { label: "Série", key: "serie" },
        { label: "Matrícula", key: "matricula" },
        { label: "Nome do Aluno", key: "nome" },
        { label: "Turma", key: "turma" },
        { label: "Tipo de Bolsa", key: "tipoBolsa" },
        { label: "Bolsa (%)", key: "bolsa" },
        { label: "Desempenho Ciclo 1 (%)", key: "d1" },
        { label: "Desempenho Ciclo 2 (%)", key: "d2" },
        { label: "Desempenho Ciclo 3 (%)", key: "d3" },
        { label: "Desempenho Ciclo 4 (%)", key: "d4" },
        { label: "Desempenho Anual (%)", key: "d_anual" }
    ];

    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             const response = await pega_ranking_soma_bolsa();
    //             const response2 = await pega_matriz_curricular();
    //             setData2(response);
    //             setMatrizCurricular(response2);
    //         } catch (error) {
    //             console.error("Erro ao buscar dados:", error);
    //         }
    //     };
    //     fetchData();
    // }, []);
    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true); // NOVO: Inicia o carregamento
            try {
                const response = await pega_ranking_soma_bolsa();
                const response2 = await pega_matriz_curricular();
                setData2(response);
                setMatrizCurricular(response2);
            } catch (error) {
                console.error("Erro ao buscar dados:", error);
                // Aqui você poderia adicionar um estado de erro para exibir uma mensagem ao usuário
            } finally {
                setIsLoading(false); // NOVO: Finaliza o carregamento, independente do resultado
            }
        };
        fetchData();
    }, []);

    const processedData = useMemo(() => {
        if (!data2.length || !matrizCurricular.length) return [];
        return data2.map(item => {
            let _ser = item.tur.substring(2, 3);
            let _gra = item.tur.substring(0, 1);
            let divisor = matrizCurricular.filter(mc => mc.ser === _ser && mc.gra === _gra && mc.sts === true && (parseInt(mc.dis) < 340 || parseInt(mc.dis) > 357)).length;
            if (divisor === 0) {
                return {
                    unidade: unidades[parseInt(item.unidade)], serie: ConverteSerie(item.serie), matricula: item.mat, nome: item.nome, turma: item.tur, tipoBolsa: item.dsc, bolsa: parseFloat(item.bol),
                    d1: 0, d2: 0, d3: 0, d4: 0, d_anual: 0
                };
            }
            const d1 = parseFloat(((parseFloat(item.c1) / (divisor * 25)) * 100).toFixed(2));
            const d2 = parseFloat(((parseFloat(item.c2) / (divisor * 25)) * 100).toFixed(2));
            const d3 = parseFloat(((parseFloat(item.c3) / (divisor * 25)) * 100).toFixed(2));
            const d4 = parseFloat(((parseFloat(item.c4) / (divisor * 25)) * 100).toFixed(2));
            const d_anual = parseFloat(((parseFloat(item.c1) + parseFloat(item.c2) + parseFloat(item.c3) + parseFloat(item.c4)) / (divisor * 100) * 100).toFixed(2));
            return {
                unidade: unidades[parseInt(item.unidade)], serie: ConverteSerie(item.serie), matricula: item.mat, nome: item.nome, turma: item.tur, tipoBolsa: item.dsc, bolsa: parseFloat(item.bol),
                d1, d2, d3, d4, d_anual
            };
        });
    }, [data2, matrizCurricular]);

    // NOVO: Efeito para atualizar a tabela quando os dados brutos mudam ou o filtro é limpo
    useEffect(() => {
        setDisplayData(processedData);
    }, [processedData]);

    const columns = useMemo(() => [

        {
            accessorKey: 'unidade',
            header: 'Unidade',
            enableColumnFilter: true,
            filterFn: 'equals',
            Filter: ({ column }) => <SelectColumnFilter column={column} />,
        },
        {
            accessorKey: 'serie',
            header: 'Série',
            enableColumnFilter: true,
            filterFn: 'arrIncludesSome',
            Filter: ({ column }) => <CheckboxDropdownFilter column={column} />,
        },
        {
            accessorKey: 'matricula',
            header: 'Matrícula',
            enableColumnFilter: false,
            cell: info => {
                const value = info.getValue();
                const perfilStr = perfil && perfil[0]?.perfil ? perfil[0].perfil : '';
                const perfilIsGestor = perfilStr === 'GESTOR';
                const perfilCode = perfilStr.slice(-2);
                const valueCode = String(value).slice(0, 2);
                if (perfilIsGestor || perfilCode === valueCode) {
                    return (
                        <a href={`${process.env.REACT_APP_FRONTEND}/boletimplusAluno/${value}`} style={{ textDecoration: 'none', color: '#006cb5' }}>
                            {value}
                        </a>
                    );
                }
                return value;

            }
        },
        { accessorKey: 'nome', header: 'Nome', enableColumnFilter: false },
        { accessorKey: 'turma', header: 'Turma', enableColumnFilter: false },
        ...(!(perfil && perfil[0]?.perfil?.startsWith("SUPERVISOR")) ? [
            {
                accessorKey: 'tipoBolsa',
                header: 'Tipo Bolsa',
                enableColumnFilter: true,
                filterFn: 'arrIncludesSome',
                Filter: ({ column }) => <CheckboxDropdownFilter column={column} />,
            },
            { accessorKey: 'bolsa', header: 'Bolsa', enableColumnFilter: false },
        ] : []),
        ...['d1', 'd2', 'd3', 'd4', 'd_anual'].map(key => ({
            accessorKey: key,
            header: () => (key === 'd_anual' ? 'D. Anual' : `D. Ciclo ${key.charAt(1)}`),
            cell: info => {
                const value = info.getValue();
                let style = {};
                if (value < 25) style = { backgroundColor: '#f8d7da', color: '#721c24' };
                else if (value < 50) style = { backgroundColor: '#ffeeba', color: '#856404' };
                else if (value < 70) style = { backgroundColor: '#fff3cd', color: '#856404' };
                else if (value < 90) style = { backgroundColor: '#d4edda', color: '#155724' };
                else style = { backgroundColor: '#cce5ff', color: '#004085' };
                return <div style={{ ...style, padding: '2px', borderRadius: '2px', textAlign: 'center' }}>{value}%</div>;
            },
            enableColumnFilter: false,
        }))
    ], []);

    const table = useReactTable({
        data: displayData, // ALTERADO para usar o estado de exibição
        columns,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getFacetedRowModel: getFacetedRowModel(),
        getFacetedUniqueValues: getFacetedUniqueValues(),
    });

    const averageRow = useMemo(() => {
        const visibleRows = table.getRowModel().rows;
        if (visibleRows.length === 0) return null;
        const numRows = visibleRows.length;
        const totals = visibleRows.reduce((acc, row) => {
            const original = row.original;
            acc.d1 += original.d1; acc.d2 += original.d2; acc.d3 += original.d3; acc.d4 += original.d4; acc.d_anual += original.d_anual;
            return acc;
        }, { d1: 0, d2: 0, d3: 0, d4: 0, d_anual: 0 });
        return {
            d1: (totals.d1 / numRows).toFixed(2), d2: (totals.d2 / numRows).toFixed(2), d3: (totals.d3 / numRows).toFixed(2), d4: (totals.d4 / numRows).toFixed(2), d_anual: (totals.d_anual / numRows).toFixed(2),
        };
    }, [table.getRowModel().rows]);

    // NOVO: Funções para gerar relatórios e limpar filtros
    const handleGenerateReport = () => {
        if (!reportType) {
            alert('Por favor, selecione um tipo de relatório.');
            return;
        }

        const filtered = processedData.filter(aluno => {
            switch (reportType) {
                case 'desempenho_abaixo': {
                    const cycles = ['d1', 'd2', 'd3', 'd4'].slice(0, referenceCycle);
                    if (cycles.length === 0) return false;
                    const sum = cycles.reduce((acc, cycle) => acc + aluno[cycle], 0);
                    const avg = sum / cycles.length;
                    return avg < threshold;
                }

                case 'queda_acentuada': {
                    if (referenceCycle < 2) return false;
                    const lastCycleKey = `d${referenceCycle}`;
                    const prevCycles = ['d1', 'd2', 'd3'].slice(0, referenceCycle - 1);
                    if (prevCycles.length === 0) return false;
                    const prevSum = prevCycles.reduce((acc, cycle) => acc + aluno[cycle], 0);
                    const prevAvg = prevSum / prevCycles.length;
                    // 'threshold' aqui é usado como o número de pontos percentuais de queda
                    return aluno[lastCycleKey] < (prevAvg - threshold);
                }

                case 'desempenho_ciclo_baixo': {
                    const cycleKey = `d${referenceCycle}`;
                    return aluno[cycleKey] < threshold;
                }

                default:
                    return false;
            }
        });

        setDisplayData(filtered);
    };

    const handleClearFilter = () => {
        setDisplayData(processedData);
        setReportType('');
    };

    // Função para renderizar o dropdown de unidades (sem alterações)
    const Experiment = (Nperfil) => {
        if (Nperfil === "GESTOR")
            return (
                <>
                    <NavDropdown.Item href="/unidade/10">Barra da Tijuca</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/01">Bento Ribeiro</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/11">Campo Grande</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/04">Cascadura</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/16">Freguesia</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/15">Ilha do Governador</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/02">Madureira</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/14">Maricá</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/06">Nilópolis</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/17">Recreio</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/03">Santa Cruz</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/09">Seropédica</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/05">Taquara</NavDropdown.Item>
                </>
            );
        if (Nperfil.startsWith("DIRETOR") || Nperfil.startsWith("SUPERVISOR")) {
            const prefix = Nperfil.startsWith("DIRETOR") ? "DIRETOR" : "SUPERVISOR";
            const numerosString = Nperfil.replace(prefix, "").trim();
            const numerosArray = numerosString.split("-");
            return numerosArray.map(cod_unidade => (
                <NavDropdown.Item key={cod_unidade} href={`/unidade/${cod_unidade}`}>
                    {unidades[parseInt(cod_unidade)]}
                </NavDropdown.Item>
            ));
        }
    };

    const infoPopover = (
        <Popover id="popover-basic">
            <Popover.Header as="h3">O que é Desempenho?</Popover.Header>
            <Popover.Body>
                <p>O <strong>Desempenho (D)</strong> mede o percentual de aproveitamento do aluno em relação à pontuação máxima possível em um ciclo ou no ano.</p>
                <p>A fórmula para o desempenho de um ciclo é:</p>
                <p><em>D = (Total de Pontos Obtidos / Pontuação Máxima Possível) × 100</em></p>
                <p>Onde a <strong>Pontuação Máxima Possível</strong> é calculada como <em>25 pontos multiplicados pelo número de disciplinas cursadas</em>.</p>
                <p>Para o desempenho anual, somam-se os pontos obtidos em todos os ciclos e divide-se pela pontuação máxima anual (que é 100 pontos multiplicados pelo número de disciplinas).</p>
                <p>O desempenho é expresso em porcentagem, variando de 0% a 100%.</p>
                <br />
                <strong>Exemplo por Ciclo:</strong>
                <p>Se um aluno cursa <strong>3 disciplinas</strong>, o máximo de pontos por ciclo é 3 x 25 = 75. Se ele obteve <strong>50 pontos</strong>, seu desempenho foi de (50 / 75) x 100 = 66,66%.</p>
                <strong>Exemplo Anual:</strong>
                <p>Considerando o mesmo aluno, se suas notas nos 4 ciclos foram 50, 60, 70 e 80, o somatório anual é <strong>260</strong>. O máximo anual seria 75 x 4 = 300 pontos. Seu desempenho anual foi de (260 / 300) x 100 = 86,66%.</p>
            </Popover.Body>
        </Popover>
    );

    return (
        <div className="Evasão">
            <div className="sticky-top painel">
                <Navbar expand="lg" className="bg-body-tertiary">
                    <Navbar.Brand href="/">
                        <img src="/novo-logo.png" alt="Santa Mônica Rede de Ensino" style={{ width: "40px", height: "40px", marginRight: "10px" }} />
                        <span style={{ color: "#006cb5", fontFamily: "inherit", fontWeight: "bold" }}>Santa Mônica Rede de Ensino</span>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <NavDropdown title="UNIDADES">
                            {perfil && Experiment(perfil[0].perfil)}
                        </NavDropdown>
                        <Nav.Link href={`/ranking`}>RANKING DE ALUNOS</Nav.Link>
                        {/* <Nav.Link href={`/ranking-series`} active>RANKING DE SÉRIES</Nav.Link> */}
                    </Navbar.Collapse>
                </Navbar>
            </div>

            <Container fluid className="mt-4">
                <h1 className="text-center mb-4">Ranking de Desempenho dos Alunos</h1>
                <center>

                    <OverlayTrigger trigger="click" placement="right" overlay={infoPopover} rootClose>
                        <Button variant="outline-info" size="sm" className="rounded-circle p-0" style={{ width: '24px', height: '24px' }}>
                            ?
                        </Button>
                    </OverlayTrigger>

                </center>


                {isLoading ? (
                    // NOVO: Bloco de UI para o estado de carregamento
                    <div className="text-center p-5">
                        <Spinner animation="border" variant="primary" role="status">
                            <span className="visually-hidden">Carregando...</span>
                        </Spinner>
                        <p className="mt-3">Carregando dados dos alunos, por favor aguarde...</p>
                    </div>
                ) : (
                    <>


                        {/* < Container fluid className="p-3 border rounded bg-light mb-4 shadow-sm">
                            <h5 className="mb-3">Gerar Listas de Alunos em Risco</h5>
                            <Row className="align-items-end">
                                <Col md={4} className="mb-2 mb-md-0">
                                    <Form.Group>
                                        <Form.Label className="fw-bold small">1. Tipo de Relatório</Form.Label>
                                        <Form.Select size="sm" value={reportType} onChange={e => setReportType(e.target.value)}>
                                            <option value="">Selecione um relatório...</option>
                                            <option value="desempenho_abaixo">Desempenho acumulado abaixo de...</option>
                                            <option value="queda_acentuada">Queda acentuada (em pontos %)</option>
                                            <option value="desempenho_ciclo_baixo">Desempenho abaixo de... (no último ciclo)</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={3} className="mb-2 mb-md-0">
                                    <Form.Group>
                                        <Form.Label className="fw-bold small">2. Considerar até o Ciclo</Form.Label>
                                        <Form.Select size="sm" value={referenceCycle} onChange={e => setReferenceCycle(parseInt(e.target.value))}>
                                            <option value="1">Ciclo 1</option>
                                            <option value="2">Ciclo 2</option>
                                            <option value="3">Ciclo 3</option>
                                            <option value="4" disabled>Ciclo 4</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={2} className="mb-2 mb-md-0">
                                    <Form.Group>
                                        <Form.Label className="fw-bold small">3. Limite / Pontos</Form.Label>
                                        <Form.Control type="number" value={threshold} onChange={e => setThreshold(parseInt(e.target.value) || 0)} size="sm" />
                                    </Form.Group>
                                </Col>
                                <Col md={3} className="d-flex align-items-end">
                                    <Button variant="primary" size="sm" className="me-2" onClick={handleGenerateReport}>Gerar Lista</Button>
                                    <Button variant="outline-secondary" size="sm" className="me-2" onClick={handleClearFilter}>Limpar Filtro</Button>


                                    <CSVLink
                                        data={displayData}
                                        headers={csvHeaders}
                                        filename={`relatorio_desempenho_alunos_${new Date().toLocaleDateString()}.csv`}
                                        separator={";"} // Importante para compatibilidade com Excel em português
                                        className="btn btn-success btn-sm"
                                    >
                                        Exportar CSV
                                    </CSVLink>
                                </Col>
                            </Row>
                        </Container> */}


                        <Table striped bordered hover responsive="md" className="shadow-sm" style={{ fontSize: '0.8rem' }}>
                            <thead className="table-primary">
                                {table.getHeaderGroups().map(headerGroup => (
                                    <tr key={headerGroup.id}>
                                        {headerGroup.headers.map(header => (
                                            <th key={header.id} style={{ verticalAlign: 'middle' }}>
                                                <div
                                                    onClick={header.column.getToggleSortingHandler()}
                                                    className={header.column.getCanSort() ? 'cursor-pointer user-select-none' : ''}
                                                >
                                                    {flexRender(header.column.columnDef.header, header.getContext())}
                                                    {{ asc: ' 🔼', desc: ' 🔽' }[header.column.getIsSorted()] ?? null}
                                                </div>
                                                {header.column.getCanFilter() ? (
                                                    <div>
                                                        {flexRender(
                                                            header.column.columnDef.Filter,
                                                            { column: header.column }
                                                        )}
                                                    </div>
                                                ) : null}
                                            </th>
                                        ))}
                                    </tr>
                                ))}
                            </thead>
                            <tbody>
                                {averageRow && !(perfil && perfil[0]?.perfil?.startsWith("SUPERVISOR")) && (
                                    <tr className="table-info">
                                        <td colSpan="7" className="text-end fw-bold">Média (dos dados exibidos):</td>
                                        <td className="fw-bold text-center">{averageRow.d1}%</td>
                                        <td className="fw-bold text-center">{averageRow.d2}%</td>
                                        <td className="fw-bold text-center">{averageRow.d3}%</td>
                                        <td className="fw-bold text-center">{averageRow.d4}%</td>
                                        <td className="fw-bold text-center">{averageRow.d_anual}%</td>
                                    </tr>
                                )}
                                {table.getRowModel().rows.map(row => (
                                    <tr key={row.id} >
                                        {row.getVisibleCells().map(cell => (
                                            <td key={cell.id} style={{ verticalAlign: 'middle' }}>
                                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </>
                )}
            </Container>

        </div >
    );
};

export default Ranking_Alunos_Serie_BolsaBT;